module.exports = __webpack_public_path__ + "img/swiper4.3df2c87e.jpg";